/* Der Rabatt-Hinweis unter dem Kaufknopf der Produktseite.
 *
 * Seit E999 (09.10.2026) gibt es keine Preistreppe nach Warenwert mehr. Es gilt:
 * Die Sets haben feste Preise. Lose Einzeldosen bekommen ab
 * WERTE.lose_ab Stueck WERTE.lose_pct Prozent, Sorten frei gemischt. Der echte
 * Rabatt kommt aus der Shopify-Rabattregel; diese Datei zeigt ihn nur an.
 *
 * DIE WERTE STEHEN NICHT HIER. Sie kommen aus den Theme-Einstellungen
 * (fb_lose_ab_stueck, fb_lose_pct, fb_gratisversand_ab) und werden von
 * sections/fb2-produkt-buehne.liquid als window.FLAVRBLOOM_STAFFEL_WERTE in
 * die Seite geschrieben. Dieselbe Rechnung steht dort in Liquid fuer den
 * ersten Satz ohne JavaScript.
 *
 * Die Produktseite kennt nur die Menge dieser einen Sorte, nicht den ganzen
 * Warenkorb. Der Satz sagt deshalb, ab wann der Rabatt gilt, und behauptet
 * nicht, wie viele Dosen noch fehlen.
 */
(function () {
  'use strict';

  var WERTE = window.FLAVRBLOOM_STAFFEL_WERTE || {
    lose_ab: 6, lose_pct: 0, gratisversand_ab: 48
  };

  function euro(betrag) {
    return betrag.toFixed(2).replace('.', ',') + ' €';
  }

  /* art: "einzeln", "trio" oder "garten"; anzahl: Dosen dieser Sorte. */
  function rechne(summe, art, anzahl) {
    var einzeln = art === 'einzeln';
    var erreicht = einzeln && WERTE.lose_pct > 0 && anzahl >= WERTE.lose_ab;
    var prozent = erreicht ? WERTE.lose_pct : 0;
    var zahlt = summe * (1 - prozent / 100);
    return { einzeln: einzeln, erreicht: erreicht, prozent: prozent,
             anzahl: anzahl, gratisversand: zahlt + 1e-9 >= WERTE.gratisversand_ab };
  }

  /* Bewusst nuechtern: was gilt. Kein "nur noch", kein "sichere dir". */
  function satz(stand) {
    var teile = [];
    if (!stand.einzeln) teile.push('Fester Setpreis');
    else if (stand.erreicht && WERTE.lose_pct > 0) teile.push('−' + WERTE.lose_pct + ' % im Warenkorb');
    else teile.push('Fester Preis je Dose');
    if (stand.gratisversand) teile.push('Versand frei');
    return teile.join(' · ');
  }

  function anteil(stand) {
    if (!stand.einzeln || stand.erreicht) return 1;
    return Math.max(0, Math.min(1, stand.anzahl / WERTE.lose_ab));
  }

  /* Erwartet <p class="staffelbalken" data-staffel> mit __spur/__wert/__text. */
  function zeige(el, summe, art, anzahl) {
    if (!el) return;
    var stand = rechne(summe, art, anzahl || 1);
    var text = el.querySelector('.staffelbalken__text');
    var wert = el.querySelector('.staffelbalken__wert');
    if (text) text.textContent = satz(stand);
    if (wert) wert.style.transform = 'scaleX(' + anteil(stand).toFixed(4) + ')';
    el.setAttribute('data-stufe', stand.prozent || 0);
    return stand;
  }

  window.FLAVRBLOOM_STAFFEL = { rechne: rechne, satz: satz, anteil: anteil,
                                zeige: zeige, euro: euro, werte: WERTE };
})();
